import { createRouter, createWebHistory } from "vue-router";

import { useAppStore } from "../store/index";
import { routes } from "./routes.ts";
import { RouteNames } from "../utils/constants.ts";
import usePersonStore from "@/store/personStore.ts";
import { storeToRefs } from "pinia";
import useClientStore from "@/store/clientStore.ts";
import { branding } from "@/config/branding";

export default function getRouter() {
  const router = createRouter({
    history: createWebHistory(),
    routes
  });

  router.beforeEach(async (to, _, next) => {
    const personStore = usePersonStore();
    useClientStore(); // Initialize client store for side effects
    const appStore = useAppStore();

    const { person } = storeToRefs(personStore);
    const isAuthenticated = person.value !== null;
    const isGuest = !isAuthenticated;

    appStore.beginDeterminateLoading();

    let nextOpts: any = undefined;

    if (to.query?.r) {
      nextOpts = {
        path: to.query.r ? to.query.r.toString() : to.path,
        // eslint-disable-next-line @typescript-eslint/no-unused-vars, no-unused-vars
        query: (({ r, ...q }) => q)(to.query)
      };
    } else {
      // Only redirect guests trying to access auth-required pages
      if (isGuest && to.meta.requiresAuth === true) {
        nextOpts = { name: RouteNames.AUTH_LOGIN };
      }
    }/* else if (isAuthenticated && to.meta.requiresClient && currentClient.value === null) {
      nextOpts = { name: RouteNames.X_CLIENT_SELECT };
    }*/

    console.log("ROUTER", {
      toPath: to.path,
      redirectTo: nextOpts,
      isAuthenticated: isAuthenticated,
      requiresAuth: to.meta.requiresAuth
    });

    next(nextOpts);
  });

  router.afterEach((to) => {
    const appStore = useAppStore();

    // Update document title
    document.title = to.meta.title
      ? `${branding.appTitle} - ${to.meta.title}`
      : branding.appTitle;

    appStore.endDeterminateLoading();
  });

  return router;
}
